import { pence as toPence, type Pence } from "@vulpari/core";
import { useState } from "react";

import { penceToPoundsInput, poundsToPence } from "../lib/money.js";

interface Props {
  label: string;
  pence: number;
  onCommit: (pence: Pence) => void;
}

/**
 * A money input in pounds that commits integer pence. It keeps the raw text
 * while editing (so partial entries like "12." are allowed), commits a parsed
 * value live for instant recompute, and tidies the display on blur.
 */
export function MoneyField({ label, pence, onCommit }: Props) {
  const [text, setText] = useState(() => penceToPoundsInput(pence));

  return (
    <label className="block">
      <span className="mb-1 block text-xs text-ink-muted">{label}</span>
      <input
        className="figure w-full rounded-lg border border-node-border bg-canvas px-2 py-1.5 text-sm text-ink outline-none focus:border-accent"
        inputMode="decimal"
        value={text}
        onChange={(event) => {
          const next = event.target.value;
          setText(next);
          const parsed = poundsToPence(next);
          if (parsed !== null) {
            onCommit(toPence(parsed));
          }
        }}
        onBlur={() => setText(penceToPoundsInput(pence))}
      />
    </label>
  );
}
